// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sunzi__guide-wrap-ZwpLa {
  position: absolute;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.7);
  margin: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sunzi__guide-wrap-ZwpLa .sunzi__guide-lz9EL {
  position: relative;
  overflow: hidden;
}
.sunzi__guide-wrap-ZwpLa .sunzi__guide-content-GEalG {
  padding: 12px;
  width: 264px;
  position: relative;
  border-radius: 4px;
  background: #fff;
}
.sunzi__guide-wrap-ZwpLa .sunzi__guide-footer-cAl2H {
  height: 70px;
}
.sunzi__guide-wrap-ZwpLa .sunzi__guide-footer-divider-Lrtq1 {
  width: 2px;
  height: 20px;
  margin: 0 auto;
  background: #fff;
}
.sunzi__guide-wrap-ZwpLa .sunzi__guide-footer-close-tlNRz {
  width: 50px;
  height: 50px;
  border: 2px solid #fff;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Guide/style.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,SAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAEA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AAdA;EAeI,kBAAA;EACA,gBAAA;AAEJ;AADI;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAGN;AADI;EACE,YAAA;AAGN;AAFM;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAIR;AAFM;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAIR","sourcesContent":[".guide-wrap {\n  position: absolute;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.7);\n  margin: 0;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .guide {\n    position: relative;\n    overflow: hidden;\n    &-content {\n      padding: 12px;\n      width: 264px;\n      position: relative;\n      border-radius: 4px;\n      background: #fff;\n    }\n    &-footer {\n      height: 70px;\n      &-divider {\n        width: 2px;\n        height: 20px;\n        margin: 0 auto;\n        background: #fff;\n      }\n      &-close {\n        width: 50px;\n        height: 50px;\n        border: 2px solid #fff;\n        margin: 0 auto;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"guide-wrap": `sunzi__guide-wrap-ZwpLa`,
	"guideWrap": `sunzi__guide-wrap-ZwpLa`,
	"guide": `sunzi__guide-lz9EL`,
	"guide-content": `sunzi__guide-content-GEalG`,
	"guideContent": `sunzi__guide-content-GEalG`,
	"guide-footer": `sunzi__guide-footer-cAl2H`,
	"guideFooter": `sunzi__guide-footer-cAl2H`,
	"guide-footer-divider": `sunzi__guide-footer-divider-Lrtq1`,
	"guideFooterDivider": `sunzi__guide-footer-divider-Lrtq1`,
	"guide-footer-close": `sunzi__guide-footer-close-tlNRz`,
	"guideFooterClose": `sunzi__guide-footer-close-tlNRz`
};
export default ___CSS_LOADER_EXPORT___;
